import React from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import { theme } from '@alycecom/ui';

import GlobalStyles from '../../styles/alyce-global-styles';
import Unsubscribe from '../Unsubscribe/Unsubscribe';

const AppModule = (): JSX.Element => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyles />
        <Unsubscribe />
      </>
    </ThemeProvider>
  </StyledEngineProvider>
);

export default AppModule;
